import {useEffect, useState} from 'react'
import {PageTitle} from '../../../_metronic/layout/core'
import {DateRangePicker} from 'rsuite'
import {addDays, differenceInDays} from 'date-fns'
import {Card} from './Card'
import {VideoViews} from './VideoViews'
import {useDispatch} from 'react-redux'
import {setTitle} from '../../redux/reducers/mainSlice'
import useUtils from './useUtils'
import CardSkeleton from '../../modules/skeleton/DashboardCardSkeleton'
import GraphSkeleton from '../../modules/skeleton/DashboardGraphSkeleton'
import VideoListSk from '../../modules/skeleton/VideolistSK'
import clsx from 'clsx'
import ViewVideo from '../videos/ViewVideo'
import {useHelper} from '../../../_metronic/helpers/useHelper'

const DashboardPage = () => {
  const [mainLoading, setMainLoading] = useState(true)
  const [graphLoading, setGraphLoading] = useState(true)
  const [videoLoading, setVideoLoading] = useState(true)
  const [videos, setVideos] = useState()
  const {fetchDashboard, fetchVideos} = useUtils()
  const [dashboardData, setDashboardData] = useState(null)
  const [graphData, setGraphData] = useState([])
  const today = new Date()
  const lastSevenDays = new Date(today)
  lastSevenDays.setDate(today.getDate() - 6)
  const [dateRange, setDateRange] = useState([lastSevenDays, today])
  const [show, setShow] = useState(false)
  const [videoLink, setVideoLink] = useState(null)

  const getDashboardData = async () => {
    try {
      setMainLoading(true)
      const result = await fetchDashboard(dateRange[0], dateRange[1])
      setDashboardData(result?.counts)
      setGraphData(result?.analytics)
    } catch (error) {
      console.log('Error fetching data: ', error?.response?.data?.message)
    } finally {
      setMainLoading(false)
    }
  }

  const getGraphData = async () => {
    try {
      setGraphLoading(true)
      const result = await fetchDashboard(dateRange[0], dateRange[1])
      setGraphData(result?.analytics)
    } catch (error) {
      console.log('Error fetching data: ', error?.response?.data?.message)
    } finally {
      setGraphLoading(false)
    }
  }

  const getVideos = async () => {
    try {
      setVideoLoading(true)
      const result = await fetchVideos()
      setVideos(result)
    } catch (error) {
      console.log('Error fetching data: ', error?.response?.data?.message)
    } finally {
      setVideoLoading(false)
    }
  }

  useEffect(() => {
    getDashboardData()
    getVideos()
  }, [])

  useEffect(() => {
    getGraphData()
  }, [dateRange])

  const handleShow = (link) => {
    setShow(true)
    setVideoLink(link)
  }


  const handleDateChange = (range) => {
    if (range && range[0] && range[1]) {
      let startTimestamp = new Date(range[0].getTime() - range[0].getTimezoneOffset() * 60000)
      let endTimestamp = new Date(range[1].getTime() - range[1].getTimezoneOffset() * 60000)
      const dayDifference = differenceInDays(endTimestamp, startTimestamp)

      if (dayDifference > 90) {
        endTimestamp = addDays(startTimestamp, 90)
      }
      // const formattedStartDate = moment(startTimestamp).format('YYYY-MM-DD')
      // const formattedEndDate = moment(endTimestamp).format('YYYY-MM-DD')
      setDateRange([startTimestamp, endTimestamp])
    } else {
      setDateRange([null, null])
    }
  }

  const predefinedBottomRanges = [
    {
      label: 'Today',
      value: [new Date(), new Date()],
    },
    {
      label: 'Last 7 days',
      value: [new Date(new Date().setDate(new Date().getDate() - 6)), new Date()],
    },
    {
      label: 'Last 30 days',
      value: [new Date(new Date().setDate(new Date().getDate() - 29)), new Date()],
    },
    {
      label: 'Last 90 days',
      value: [new Date(new Date().setDate(new Date().getDate() - 89)), new Date()],
    },
  ]

  return (
    <>
      {mainLoading ? (
        <CardSkeleton />
      ) : (
        <div className='d-flex responsive justify-content-center flex-wrap gap-3 mt-10'>
          <Card
            className='card'
            color='primary'
            title='Total Programs'
            text={dashboardData?.programs}
          />

          <Card
            className='card '
            color='primary'
            title='Total Courses'
            text={dashboardData?.courses}
          />

          <Card
            className='card  '
            color='primary'
            title='Total Modules'
            text={dashboardData?.modules}
          />

          <Card
            className='card'
            color='primary'
            title='Total Units'
            text={dashboardData?.units}
          />

          <Card className='card ' color='primary' title='Videos' text={dashboardData?.videos} />

          <Card
            className='card'
            color='primary'
            title='Total Users'
            text={dashboardData?.totalUsers}
          />

          {/* <Card
            className='card '
            color='primary'
            title='Total Quizes'
            text={dashboardData?.programs}
          /> */}

          <Card
            className='card  '
            color='primary'
            title='Video Views'
            text={dashboardData?.totalViews}
          />

          <Card
            className='card '
            color='primary'
            title='Active Subscribers'
            text={dashboardData?.activeUsers}
          />

          <Card
            className='card'
            color='primary'
            title='Non Active Subscribers'
            text={dashboardData?.nonActiveUsers}
          />
        </div>
      )}
   
      <div className='row mt-10'>
        <div className='d-flex justify-content-end mb-8'>
          <DateRangePicker
            value={dateRange}
            ranges={predefinedBottomRanges}
            placeholder='Select date range'
            placement='leftStart'
            format='yyyy-MM-dd'
            cleanable={false}
            style={{width: 300}}
            onChange={handleDateChange}
          />
        </div>

        <div className='col-xl-6'>
          {graphLoading ? (
            <GraphSkeleton title='Video Views' />
          ) : (
            <VideoViews
              name='Views'
              title='Video Views'
              className='card-xl-stretch mb-xl-8'
              x={graphData?.views?.map((e) => e.date)}
              y={graphData?.views?.map((e) => e.count)}
            />
          )}
        </div>

        <div className='col-xl-6'>
          {graphLoading ?  (
            <GraphSkeleton title='Subscribers' />
          ) : (
            <VideoViews
              name='Subscribers'
              title='Subscribers'
              className='card-xl-stretch mb-xl-8'
              x={graphData?.subscribers?.map((e) => e.date)}
              y={graphData?.subscribers?.map((e) => e.count)}
            />
          )}
        </div>
      </div>

      {videoLoading? <VideoListSk/> :
   (   
   <>
    <div className='pt-10 pb-6'>
    <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bold fs-3 mb-1'>Trending Videos</span>
        </h3>
    </div>
        <div
        className={clsx(
          'card-body pb-10 d-flex px-10',
          videos?.count <= 2 ? 'justify-content-start' : 'justify-content-center'
        )}
      >
        <div className='mt-3 d-flex justify-content-center align-items-start gap-10 flex-wrap'>
          {videos?.length > 0 &&
            videos?.map((val, index) => (
              <div
                className='shadow-lg overflow-hidden  position-relative bg-white text-black'
                key={index}
                style={{width: '220px', borderRadius: '9px'}}
              >
                <div className='player-wrapper position-relative'>
                <img
                        src={
                          val?.thumbnailUrl || 'https://placehold.co/220x160?text=Loading'
                        }
                        onClick={() => handleShow(val.link)}
                        alt='video thumbnail'
                        style={{width: '100%', height: '160px', objectFit: 'cover'}}
                      />
                 
                </div>
                <hr className='hr' />
                <div className='px-2' style={{height: '90px'}}>
                  <div className='fw-bold fs-7'>
                    {val?.title?.length > 28 ? val.title.slice(0, 28) + ' ....' : val.title}
                  </div>
                  <div className='mb-3 text-start fs-8 fw-light mt-2'>
                    {val?.description?.length > 90
                      ? val.description.slice(0, 90) + ' ....'
                      : val.description}
                  </div>
                </div>
              </div>
            ))}
        </div>
      </div>
      </>
    )}
     <ViewVideo show={show} onHide={() => setShow(false)} videoLink={videoLink} />
    </>
  )
}
const DashboardWrapper = () => {
  const dispatch = useDispatch()
  dispatch(setTitle('Dashboard'))

  return (
    <>
      <PageTitle>Dashboard</PageTitle>
      <DashboardPage />
    </>
  )
}

export {DashboardWrapper}
